(() => {
  'use strict';
  document.addEventListener('click', event => {
    const link = event.target.closest('a[href]');
    if (!link || event.defaultPrevented) return;
    let target;
    try { target = new URL(link.href, location.href); } catch { return; }
    if (!['wa.me', 'api.whatsapp.com', 'web.whatsapp.com'].includes(target.hostname)) return;
    if (window.Shopify?.customerPrivacy?.analyticsProcessingAllowed() !== true) return;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'pp_whatsapp_click',
      event_id: crypto.randomUUID(),
      product_type: location.pathname.endsWith('/pages/customize') ? 'custom_enamel_pin' : 'contact',
      locale: document.documentElement.lang,
      quantity_bucket: undefined,
      source: undefined,
      reason: undefined
    });
  });
})();
